module.exports = __webpack_public_path__ + "_/skins/Internet-Archive-f86f47ed539e393678f805fe776e4d30.wsz";